import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Gallery.css';
import logo from '../assets/LOGO.png'; // Import the logo

// Correctly import the existing PNG images
import img1 from '../assets/gallery/img1.png';
import img2 from '../assets/gallery/img2.png';

function Gallery() {
  const images = [
    { id: 1, src: img1, alt: 'Kitchen Table', title: 'Kitchen Table' },
    { id: 2, src: img2, alt: 'Coffee Table', title: 'Coffee Table' },
  ];

  return (
    <section id="gallery" className="py-5 rjc-gallery-section">
      <Container>
        <div className="gallery-logo-container">
          <img src={logo} alt="Russell Blanchard Creations logo" className="gallery-logo" />
        </div>
        <h2 className="text-center mb-5 rjc-section-title">Our Creations</h2>
        <Row>
          {images.map(image => (
            <Col md={6} lg={4} className="mb-4" key={image.id}>
              <Card className="h-100 rjc-gallery-card">
                <Card.Img variant="top" src={image.src} alt={image.alt} className="rjc-gallery-img" />
                <Card.Body>
                  <Card.Title className="rjc-gallery-title">{image.title}</Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Gallery;